import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment, endpoints } from '@environment';
import {
  AssetSnapshot,
  CreateAssetSnapshotRequest,
  PagedRequest,
  PagedResponse,
  UpdateAssetSnapshotRequest,
} from '@core/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AssetSnapshotService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.assetSnapshots}`;

  getAll(assetAccountId: string): Observable<AssetSnapshot[]> {
    const params = new HttpParams().set('assetAccountId', assetAccountId);
    return this.http.get<AssetSnapshot[]>(this.baseUrl, { params });
  }

  getPaged(
    assetAccountId: string,
    request: PagedRequest
  ): Observable<PagedResponse<AssetSnapshot>> {
    const params = new HttpParams().set('assetAccountId', assetAccountId);
    return this.http.post<PagedResponse<AssetSnapshot>>(
      `${this.baseUrl}/paged`,
      request,
      { params }
    );
  }

  getById(id: string): Observable<AssetSnapshot> {
    return this.http.get<AssetSnapshot>(`${this.baseUrl}/${id}`);
  }

  create(payload: CreateAssetSnapshotRequest): Observable<AssetSnapshot> {
    return this.http.post<AssetSnapshot>(this.baseUrl, payload);
  }

  update(payload: UpdateAssetSnapshotRequest): Observable<AssetSnapshot> {
    return this.http.put<AssetSnapshot>(this.baseUrl, payload);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
